import { render, staticRenderFns } from "./mating-dam-sire-details-container.vue?vue&type=template&id=7afb58fd&scoped=true&lang=pug"
import script from "./mating-dam-sire-details-container.js?vue&type=script&lang=js&external"
export * from "./mating-dam-sire-details-container.js?vue&type=script&lang=js&external"
import style0 from "./mating-dam-sire-details-container.vue?vue&type=style&index=0&id=7afb58fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afb58fd",
  null
  
)

export default component.exports